import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";

export class Product extends FBase {

	name: string = null;
	price: number = null;
	thumbnail: string = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace Product {
	export const PATH = 'products';
}
